<template>
  <div>
    <app-cells>
      <h1 class="title">Climbing groups</h1>
    </app-cells>
    <app-tabs :tabs="tabs" />
    <transition name="fade" mode="out-in">
      <router-view @open-preview="openPreview" />
    </transition>
    <GroupPreviewModal
      v-if="selectedModalId"
      :key="selectedModalId"
      :group-id="selectedModalId"
      @close="closeRouteModal"
    />
  </div>
</template>

<script>
import AppTabs from '@/components/AppTabs'
import GroupPreviewModal from './GroupPreviewModal'
import { modalRoute } from '@/views/crm/modalRoute'

export default {
  name: 'ClimbingGroupsLayout',
  components: { AppTabs, GroupPreviewModal },
  mixins: [modalRoute('preview')],
  data() {
    return {
      tabs: [
        { name: 'climbing-groups', label: 'Upcoming' },
        { name: 'climbing-groups-tour', label: 'In tour' },
        { name: 'climbing-groups-summit', label: 'Summit' },
        { name: 'climbing-groups-archive', label: 'Archive' },
      ],
    }
  },
  methods: {
    openPreview({ groupId, triggerElement }) {
      this.openRouteModal(groupId, triggerElement)
    },
  },
}
</script>
